import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Priority, PriorityHelper } from '@libs/vc-core-lib';
import { IconComponent, TextRendererPipe } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-task-priority',
    templateUrl: './task-priority.component.html',
    styleUrls: ['./task-priority.component.scss'],
    imports: [TextRendererPipe, IconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskPriorityComponent {
    @Input()
    priority!: Priority;

    priorityColorMap: Map<string, string> = new Map<string, string>()
        .set(Priority.HIGH, 'var(--error-text-color)')
        .set(Priority.LOW, 'var(--success-text-color)')
        .set(Priority.MEDIUM, 'var(--warning-color)');

    priorityIconMap: Map<string, string> = new Map<string, string>()
        .set(Priority.HIGH, 'arrow_upward')
        .set(Priority.LOW, 'arrow_downward')
        .set(Priority.MEDIUM, 'arrow_upward');

    priorityItemRenderer = (priority: Priority): string => PriorityHelper.getPriorityString(priority);
}
